<template>
  <div class="right_bar" :class="{ show_content: showIndex > 0 }">
    <div class="bar_nav">
      <ul>
        <li class="wxPcIcon" @mouseenter="showTinyWechatQrCode=true" @mouseleave="showTinyWechatQrCode=false">
          <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/wxpc-icon.png" alt="">
          <span class="hover_box">
            <a>企微客服</a>
          </span>
          <div class="tinyWechatQrCode" v-show="showTinyWechatQrCode">
            <img class="tinyWxQrcode" src="https://resource.rcclchina.com.cn/wechatMiniProgram/pc-sideBaricon.png" alt="">
            <p>添加企微客服<br/>领取专属福利</p>
          </div>
        </li>
        <li class="show_content shoppingCart" @click="setLeftMenuIndex(1)">
          <i class="detail_ico_40 shopping_cart"></i>
          <span class="hover_box">购物车</span>
          <em class="badge" v-show="shoppingCartCount > 0">{{
            shoppingCartCount
          }}</em>
        </li>
        <li class="cruiseSeach">
          <i class="detail_ico_40 searce_ico"></i>
          <span class="hover_box">
            <a href="/Rccl.Cruise/CruiseSearch/Search" @click="gioTrackBtn('elvSch')">航线搜索</a>
          </span>
        </li>
        <li class="show_content collections" @click="setLeftMenuIndex(3)">
          <i class="detail_ico_40 collection_ico"></i>
          <span class="hover_box">收藏夹</span>
        </li>
        <li class="show_content common_problem" @click="setLeftMenuIndex(4)">
          <i class="detail_ico_40 problem_ico"></i>
          <span class="hover_box">常见问题</span>
        </li>
        <li class="cruiseSeach">
          <div class="hover_menu_icon">
            <img src="https://resource.rcclchina.com.cn/questionnaire/icons/feedback.png" alt=""/>
          </div>
          <span class="hover_box">
            <a href="/Rccl.CustomPage/questionnaire/SurveyQuestion?type=HOME">使用反馈</a>
          </span>
        </li>
        <li class="user_center">
          <i class="detail_ico_40 personal_ico"></i>
          <span class="hover_box">
            <a href="/Rccl.UserCenter/CustomerInfo/Info" @click="gioTrackBtn('personalCenter')">个人中心</a>
          </span>
        </li>
        <li>
          <i class="detail_ico_40 goback_ico"></i>
          <a @click="goTop" class="hover_box">返回顶部</a>
        </li>
      </ul>
    </div>
    <div class="bar_content" v-show="showIndex > 0">
      <ShoppingCart v-show="showIndex == 1" :closeMenu="closeMenu" />

      <WishListFloatMenu v-if="showIndex == 3" :closeMenu="closeMenu" />
      <TopFaq v-else-if="showIndex == 4" :closeMenu="closeMenu" />
      <div v-else class="f-dn"></div>
    </div>
    <div
      class="right_bar_bg"
      v-show="showIndex > 0"
      @click="setLeftMenuIndex(-1)"
    ></div>
  </div>
</template>

<script>
const ShoppingCart = () => import("@/components/FloatMenu/ShoppingCart");
const WishListFloatMenu = () => import("@/components/FloatMenu/WishListFloatMenu");
const TopFaq = () => import("@/components/FloatMenu/TopFaq");
import { gioTracking } from "@/utilities/tools";
export default {
  name: "FloatMenu",
  components: {
    ShoppingCart,
    WishListFloatMenu,
    TopFaq,
  },
  beforeMount() {
    this.getShoppingCartCount();
  },
  data() {
    return {
      showTinyWechatQrCode: false
    };
  },
  methods: {
    goTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
			this.gioTrackBtn('toTop')
    },
    getShoppingCartCount() {
      if (this.userToken && this.userToken.length > 0) {
        return this.$store.dispatch("GET_SHOPPING_CART_COUNT", this.userToken);
      }
    },
    getShoppingCart() {
      if (this.userToken && this.userToken.length > 0) {
        return this.$store.dispatch("GET_SHOPPING_CART", this.userToken);
      }
    },
    closeMenu() {
      this.setLeftMenuIndex(-1);
    },
    setLeftMenuIndex(index) {
      this.$store.commit("SET_LEFT_MENU", index);
			switch (index) {
				case 1:
					this.gioTrackBtn('cart'); break;
				case 3:
					this.gioTrackBtn('fav'); break;
				case 4:
					this.gioTrackBtn('faq'); break;
				default: break;
			}
    },
		gioTrackBtn (btnType) {
			gioTracking('track', 'evt_ButtonClicked', {
				'btnType': btnType
			})
		}
  },
  computed: {
    userToken() {
      return this.$store.state.user.userToken;
    },
    shoppingCartCount() {
      return this.$store.state.booking.shoppingCartCount;
    },
    showIndex() {
      return this.$store.state.page.leftMenuIndex;
    },
  },
  watch: {
    showIndex(newValue) {
      if (newValue == 1) {
        this.getShoppingCart();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.right_bar {
  width: 280px;
  height: 100%;
  position: fixed;
  right: -280px;
  top: 0;
  z-index: 999;
  border-left: 5px solid #54a3de;
  background: #fff;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
  .bar_nav {
    position: absolute;
    right: 102%;
    top: 30%;
    z-index: 901;
    ul {
      margin: 0;
      li {
        background: #54a3de;
        margin-bottom: 1px;
        position: relative;
        cursor: pointer;
        .hover_box {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          font-size: 12px;
          color: #282b2c;
          text-align: center;
          padding: 4px;
          background: #f9c804;
          opacity: 0;
          visibility: hidden;
          -webkit-transition: all 0.3s ease;
          -o-transition: all 0.3s ease;
          -moz-transition: all 0.3s ease;
          transition: all 0.3s ease;
        }
        .badge {
          background: #ff3022;
          color: #fff;
          position: absolute;
          top: -10px;
          right: 0;
          font-style: normal;
          padding: 3px 5px;
        }
      }
      li:last-child {
        margin-bottom: 0;
      }
      li:hover .hover_box {
        visibility: visible;
        opacity: 1;
      }
      .cur {
        background: #f9c804;
      }
    }
  }
  .right_bar_bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 900;
    background-color: transparent;
  }
  .bar_content {
    position: relative;
    height: 100%;
    z-index: 901;
  }
}
.right_bar.show_content {
  right: 0;
  background: #f2f1ed;
}
.hover_menu_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  & > img {
    display: block;
    width: 20px;
    height: 22px;
  }
}
.wxPcIcon{
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  img{
    width: 25px;
    height: 20px;
  }
  .tinyWechatQrCode{
    width: 240px;
    height: 243px;
    background-color: #fff;
    position: absolute;
    left: -243px;
    top: 0;
    font-size: 22px;
    color: #000000;
    text-align: center;
    padding-top: 27px;
    font-weight: 500;
    .tinyWxQrcode{
      width: 120px;
      height: 120px;
      margin-bottom: 15px;
    }
  }
}

</style>
